















import Component, { mixins } from "vue-class-component";
import { Page } from "@scrile/api-provider/dist/api/PageProvider";
import WithStateRedirectPath from "@/mixins/WithStateRedirectPath";
import providers from "@/lib/api";

@Component({ name: "FooterPolicy" })
export default class FooterPolicy extends mixins(WithStateRedirectPath) {
  public pages: Page[] = [];

  public get contactUsLocation() {
    return this.$router.resolve({ name: "messages", params: { userId: "1" } });
  }

  public contactClick() {
    this.stateRedirectPath = this.contactUsLocation.location;
    this.$router.push({ name: "login" });
  }

  public async created() {
    this.pages = await providers.PageProvider.find();
  }
}
